/* eslint-disable @typescript-eslint/explicit-function-return-type */
import config from '../config/index';

async function getGiftVoucherSearchList(
  tenantBrandBusinessId,
  mobile,
  giftVoucherCode,
  from = 0,
  size = 10,
  fromDate,
  toDate,
  status = ''
) {
  return await fetch(
    `${config.ruleServerUrl}/gift-vouchers/businessUnit/${tenantBrandBusinessId}/all?mobile=${mobile}&offerCode=${giftVoucherCode}&from=${from}&size=${size}&fromDate=${fromDate}&toDate=${toDate}&status=${status}`,
    {
      credentials: 'include',
      method: 'GET',
      headers: {
        'Content-type': 'application/json'
      }
    }
  ).then(r => r.json());
}

async function exportGiftVoucherSearchListAsCSV(
  tenantBrandBusinessId,
  mobile,
  giftVoucherCode,
  fromDate,
  toDate,
  status = ''
) {
  return await fetch(
    `${config.ruleServerUrl}/gift-vouchers/businessUnit/${tenantBrandBusinessId}/all/exportCSV?mobile=${mobile}&offerCode=${giftVoucherCode}&fromDate=${fromDate}&toDate=${toDate}&status=${status}`,
    {
      credentials: 'include',
      method: 'GET',
      headers: {
        'Content-type': 'application/json'
      }
    }
  ).then(r => r.blob());
}

async function getGiftVoucherSearchCount(
  tenantBrandBusinessId,
  mobile,
  giftVoucherCode,
  fromDate,
  toDate,
  status = ''
) {
  return await fetch(
    `${config.ruleServerUrl}/gift-vouchers/businessUnit/${tenantBrandBusinessId}/all/count?mobile=${mobile}&offerCode=${giftVoucherCode}&fromDate=${fromDate}&toDate=${toDate}&status=${status}`,
    {
      credentials: 'include',
      method: 'GET',
      headers: {
        'Content-type': 'application/json'
      }
    }
  ).then(r => r.json());
}

export default {
  getGiftVoucherSearchList,
  getGiftVoucherSearchCount,
  exportGiftVoucherSearchListAsCSV
};
